import React, { memo, useEffect } from "react";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker } from 'react-date-range';
import { CustomDialog } from "~components";
import { useDashboard, useSales } from "~store";
import { format } from "date-fns";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const DashboardFilter = () => {

  const [dashboardState, dashboardActions] = useDashboard();
  const [, salesActions] = useSales();

  useEffect(() => {
    const fetch = async () => {
      dashboardActions.setState({
        dataLoading: true,
        usersLoading: true,
        downloadsLoading: true
      });

      salesActions.getSalesTotal({
        status: "succeeded",
        dateFilter: dashboardState.dateFilter
      });

      await dashboardActions.fetchData();
      dashboardActions.setState({dataLoading: false});

      await dashboardActions.fetchLatestRegistration();
      dashboardActions.setState({usersLoading: false});

      await dashboardActions.fetchDownloads();
      dashboardActions.setState({downloadsLoading: false});
    }
    fetch();
  }, [dashboardState.dateFilter])

  return (

    <CustomDialog
      dividers={false}
      dialogActions={false}
      triggerButton={
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>Filter by Date Range</Tooltip>}
        >
          <button type="button" className="btn btn-light-primary font-weight-bold btn-sm">
            {format(dashboardState.dateFilter.startDate, 'MMM dd, yyy')} - {format(dashboardState.dateFilter.endDate, 'MMM dd, yyyy')}
            <i className={"far fa-calendar-alt icon-sm-ms ml-2"} />
          </button>
        </OverlayTrigger>
      }
    >
      <DateRangePicker
        onChange={item => dashboardActions.setState({dateFilter: item.selection})}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={[dashboardState.dateFilter]}
        direction="horizontal"
      />
    </CustomDialog>
  );
}

export default memo(DashboardFilter);
